import { Pair, mk_pair } from "widgets-for-react";
import { ImageSize } from "../../cms/blocks/types.gen";
import { WordPress } from "../../wordpress/wordpress_api";

export type ExtraImages = 
| 'media' 
| 'teaser'

// HYPOTRUST

//home pageheader : crop 45:29
| '450x260'
| '900x580'
| '1800x1160'

// products & other pages pageheader : crop 1:1
| '260x260'
| '580x580'
| '1160x1160'

// quote block : crop 1:1
| '360x360'
| '620x620'
| '1240x1240'

// updates block (called latest) : crop 88:51
| '440x255'
| '880x510'
| '1320x765'

// media block : no crop
| '460w'
| '920w'
| '1840w'

// grid with image block : no crop
| '440w'
| '880w'
| '1320w'

//video library
| '580x440'
| '880x510'
| '1400x510'


export let get_default_data_src : () => ImageSize<ExtraImages> = () => "full"
export let get_default_data_srcset : () => Pair<ImageSize<ExtraImages>, string>[] = () => 
  [
    //example: mk_pair('media_w432' as ExtraImages, "424w"),
  ]


export function getImageSize<t>(media: WordPress.Image, size: string | ImageSize<t>) : string {
  let image_size: string = size.toString()
  if (media && media.media_details && media.media_details.sizes && media.media_details.sizes) {
    return media.media_details.sizes[image_size] ? 
      media.media_details.sizes[image_size].source_url
    : media.media_details.sizes['full'] && media.media_details.sizes['full'].source_url ? 
      media.media_details.sizes['full'].source_url 
    : ''
  }

  return ''
}

export function getImageAttribute<t>(media: WordPress.Image, size: string | ImageSize<t>, attr: string) : string {
  let image_size: string = size.toString()
  if (media && media.media_details && media.media_details.sizes && media.media_details.sizes) {
    return media.media_details.sizes[image_size] && media.media_details.sizes[image_size][attr] ? 
      media.media_details.sizes[image_size][attr] 
    : media.media_details.sizes['full'] && media.media_details.sizes['full'][attr] ? 
      media.media_details.sizes['full'][attr] 
    : ''
  }

  return ''
}

// HYPOTRUST - Image sizes

export let home_header_src : () => ImageSize<ExtraImages> = () => "450x260"
export let home_header_srcset : () => Pair<ImageSize<ExtraImages>, string>[] = () => 
  [
    mk_pair('450x260' as ExtraImages, "450w"),
    mk_pair('900x580' as ExtraImages, "900w"),
    mk_pair('1800x1160' as ExtraImages, "1800w"),
  ]

export let page_header_src : () => ImageSize<ExtraImages> = () => "260x260"
export let page_header_srcset : () => Pair<ImageSize<ExtraImages>, string>[] = () => 
  [
    mk_pair('260x260' as ExtraImages, "260w"),
    mk_pair('580x580' as ExtraImages, "580w"),
    mk_pair('1160x1160' as ExtraImages, "1160w"),
  ]

export let quote_src : () => ImageSize<ExtraImages> = () => "360x360"
export let quote_srcset : () => Pair<ImageSize<ExtraImages>, string>[] = () => 
[
  mk_pair('360x360' as ExtraImages, "360w"),
  mk_pair('620x620' as ExtraImages, "620w"),
  mk_pair('1240x1240' as ExtraImages, "1240w"),
]

export let updates_src : () => ImageSize<ExtraImages> = () => "440x255"
export let updates_srcset : () => Pair<ImageSize<ExtraImages>, string>[] = () => 
  [
    mk_pair('440x255' as ExtraImages, "440w"),
    mk_pair('880x510' as ExtraImages, "880w"),
    mk_pair('1320x765' as ExtraImages, "1320w"),
  ]

export let media_src : () => ImageSize<ExtraImages> = () => "460w"
export let media_srcset : () => Pair<ImageSize<ExtraImages>, string>[] = () => 
  [
    mk_pair('460w' as ExtraImages, "460w"),
    mk_pair('920w' as ExtraImages, "920w"),
    mk_pair('1840w' as ExtraImages, "1840w"),
  ]

export let grid_src : () => ImageSize<ExtraImages> = () => "440w"
export let grid_srcset : () => Pair<ImageSize<ExtraImages>, string>[] = () => 
  [
    mk_pair('440w' as ExtraImages, "440w"),
    mk_pair('880w' as ExtraImages, "880w"),
    mk_pair('1320w' as ExtraImages, "1320w"),
  ]

export let video_library_src : () => ImageSize<ExtraImages> = () => "580x440"
export let video_library_srcset : () => Pair<ImageSize<ExtraImages>, string>[] = () => 
  [
    mk_pair('580x440' as ExtraImages, "5800w"),
    mk_pair('880x510' as ExtraImages, "880w"),
    mk_pair('1400x510' as ExtraImages, "1400w"),
  ]


// WEBPACK FOOTER //
// ./Client/components/public_site/utils/extra_images.mod.tsx